module.exports = __webpack_public_path__ + "static/media/bg-login.12f3fc15.png";